"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

/**
 * Reusable table title component with tooltip
 */
var TableTitle = function TableTitle(_ref) {
  var title = _ref.title,
      tooltipMessage = _ref.tooltipMessage,
      className = _ref.className;
  return (0, _preact.h)("div", {
    className: className
  }, title, (0, _preact.h)(_Tooltip.default, {
    position: "center",
    trigger: (0, _preact.h)(_assets.default, {
      icon: "question",
      size: 16,
      customClass: "icon-info"
    }),
    customClasses: "metric-help-tooltip",
    tooltipMessage: tooltipMessage
  }));
};

var _default = TableTitle;
exports.default = _default;